// extracted by mini-css-extract-plugin
export var container = "Content-module--container--381a1";
export var header = "Content-module--header--e181d";
export var pageContent = "Content-module--pageContent--d314d";